module.exports = __webpack_public_path__ + "front/img/40.c1014942.jpg";